module.exports = __webpack_public_path__ + "img/Weapon_188.fe26c085.png";